import React from "react"
import styled from "styled-components"
import LoginView from "../FirebaseAuth/LoginView"

export default function AuthSection() {
  return (
    <Wrapper>
      <Auth>
        <LoginView />
      </Auth>
      <div className="wave1"></div>
      <div className="wave2"></div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .wave1 {
    position: relative;
    align-self: top;
  }
  .wave2 {
  }
`

const Auth = styled.div`
  position: relative;
  top: 200px;
`
